// extracted by mini-css-extract-plugin
export default {"media-fallback":"media-fallback__2AYMK"};